// export default  URL = "http://137.184.203.47/";
export const  URL_TV = "https://api-hubersuhnercast.sane.agency/api/dashboard";
export const  URL_LOGIN = "https://idp-hubersuhnercast.sane.agency/auth";


